import script from "./HomeComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeComponent.vue?vue&type=script&setup=true&lang=js"

import "./HomeComponent.vue?vue&type=style&index=0&id=8a28fd0e&lang=css"

const __exports__ = script;

export default __exports__